import $ from "jquery";
import truncate from "truncate-html";

export function init() {
    if ($("[data-truncate]").length) {
        $("[data-truncate]").each(function () {
            const maxLength = $(this).data("max-length") || 200;
            let content = $(this).html();
            let truncated = truncate(content, maxLength);

            if (!truncated.endsWith("...")) return;

            content += ` <a href="#" class="toggle-comments fw-semibold">View less</a>`;
            truncated += ` <a href="#" class="toggle-comments fw-semibold">View more</a>`;

            $(this).html(truncated);

            $(this).on("click", ".toggle-comments", function (e) {
                e.preventDefault();

                if ($(this).text() === "View more") {
                    $(this).parent().html(content);
                } else {
                    $(this).parent().html(truncated);
                }
            });
        });
    }
}

export default init();
